import css from './css/bitmovin-player-ui'
import Color from '../color'

/**
 * All UI functionality for the bitmovin player.
 * 
 * @author Stan Hurks
 */
export default class UI {
    /**
     * Generates the bitmovin-player-ui CSS file with edited colors
     * for the icons.
     * 
     * @param colors The colors
     */
    public static replaceIconColors = (colors: { inactive: Color, active: Color }) => {
        return css
            .replace(/%23INACTIVE/g, `%23${Color.toHex(colors.inactive)}`)
            .replace(/%23ACTIVE/g, `%23${Color.toHex(colors.active)}`)
    }
}